export default "__VITE_ASSET__B86$i6b1__"